import type {
  ChangeDesktopUpdateProductRequest,
  CreateGatewayPrincipalReply,
  CreateGatewayPrincipalRequest,
  DeleteGatewayPrincipalReply,
  DeleteGatewayPrincipalRequest,
  DesktopUpdateApprovalReply,
  DesktopUpdateMutationReply,
  GetDesktopUpdatesDocumentReply,
  GetGatewayPrincipalClientConfigsReply,
  GetGatewayPrincipalsDocumentReply,
  GetGatewayPrincipalUsageSummaryReply,
  UpdateGatewayPrincipalReply,
  UpdateGatewayPrincipalRequest,
} from '@/types';
import api from './api';

const DESKTOP_UPDATES_PATH = '/api/v1/app-config/desktop-updates';

export const appConfigAdminApi = {
  getGatewayPrincipalsDocument:
    async (): Promise<GetGatewayPrincipalsDocumentReply> => {
      return api.get('/api/v1/app-config/gateway-principals');
    },

  createGatewayPrincipal: async (
    data: CreateGatewayPrincipalRequest,
  ): Promise<CreateGatewayPrincipalReply> => {
    return api.post('/api/v1/app-config/gateway-principals', data);
  },

  updateGatewayPrincipal: async (
    data: UpdateGatewayPrincipalRequest,
  ): Promise<UpdateGatewayPrincipalReply> => {
    return api.post('/api/v1/app-config/gateway-principals/update', data);
  },

  deleteGatewayPrincipal: async (
    data: DeleteGatewayPrincipalRequest,
  ): Promise<DeleteGatewayPrincipalReply> => {
    return api.post('/api/v1/app-config/gateway-principals/delete', data);
  },

  getGatewayPrincipalClientConfigs: async (
    uid: string,
    model?: string,
  ): Promise<GetGatewayPrincipalClientConfigsReply> => {
    return api.get(
      `/api/v1/app-config/gateway-principals/${encodeURIComponent(uid)}/client-configs`,
      {
        params: model ? { model } : undefined,
      },
    );
  },

  getGatewayPrincipalUsageSummary: async (
    uid: string,
    days = 30,
  ): Promise<GetGatewayPrincipalUsageSummaryReply> => {
    return api.get(
      `/api/v1/app-config/gateway-principals/${encodeURIComponent(uid)}/usage-summary`,
      {
        params: { days },
      },
    );
  },

  getDesktopUpdatesDocument: async (
    approvalPageToken = '',
  ): Promise<GetDesktopUpdatesDocumentReply> => {
    return api.get(DESKTOP_UPDATES_PATH, {
      params: {
        approvalPageSize: 50,
        ...(approvalPageToken ? { approvalPageToken } : {}),
      },
    });
  },

  changeDesktopUpdateProduct: async (
    data: ChangeDesktopUpdateProductRequest,
  ): Promise<DesktopUpdateMutationReply> => {
    return api.post(`${DESKTOP_UPDATES_PATH}/products/change`, data);
  },

  approveDesktopUpdate: async (
    approvalId: string,
  ): Promise<DesktopUpdateApprovalReply> => {
    return api.post(`${DESKTOP_UPDATES_PATH}/approvals/approve`, {
      approvalId,
    });
  },

  rejectDesktopUpdate: async (
    approvalId: string,
    reason: string,
  ) => {
    return api.post(`${DESKTOP_UPDATES_PATH}/approvals/reject`, {
      approvalId,
      reason,
    });
  },

  withdrawDesktopUpdate: async (
    approvalId: string,
  ) => {
    return api.post(`${DESKTOP_UPDATES_PATH}/approvals/withdraw`, {
      approvalId,
    });
  },
};
